import React from 'react';
import './SearchBar.scss';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon';

const SearchBar = props => {
  const placeHolder =
    props && props.placeHolder
      ? props.placeHolder
      : 'Search for fruits, dry-fruits.. ';
  return (
    <div className="search-bar">
      <Link to="/search" className="dummy-input">
        <div className="search-bar--placeholder">{placeHolder}</div>
        <Icon size={24} class="search-bar--search-icon icon-back-bar-search" />
      </Link>
    </div>
  );
};

export default SearchBar;
